import onSaleImage from './images/on-sale.png';

/**
 * The legacy card's On Sale ribbon (`Components.ProductBadges.OnSale`): the same art in
 * the same place, across the top right corner of the cover at half its width.
 */
export default function OnSaleBadge() {
  return (
    <img
      src={onSaleImage}
      alt="On Sale!"
      width={192}
      height={192}
      className="pointer-events-none absolute right-0 top-0 z-[2] h-auto w-1/2"
    />
  );
}
